export class RegistrationFormModel {
  FirstName: string = "";
  LastName: string = "";
  address: string = "";
  phoneNumber: string = "";
  emailAddress: string = "";
  ninNumber: number = null;
  companyType: string = "";
  rcNumber: number = null;
  userName: string = "";
  password: string = "";
  confirmpassword: string = "";
}

export class PhoneNumberValidationModel {
  isPhoneValid: boolean = true;
  validationMessage: string = "";
  isPhoneRequired: boolean = true;
}


export class ValidationModel {
  isFirstNameValid: boolean = true;
  firstNameValidationMessage: string = "First Name is required";

  isLastNameValid: boolean = true;
  lastNameValidationMessage: string = "Last Name is required";

  //isaddressValid: boolean = true;
  //addressValidationMessage: string = "Telephone No 1. is required";

  isphoneNumberValid: boolean = true;
  phoneNumberValidationMessage: string = "Phone No. is required";

  isninNumberValid: boolean = true;
  ninNumberValidationMessage: string = "NIN Number is required";

  iscompanyTypeValid: boolean = true;
  companyTypeValidationMessage: string = "Company Type is required";


  isrcNumberValid: boolean = true;
  rcNumberValidationMessage: string = "RC Number is required";

  isuserNameValid: boolean = true;
  userNameValidationMessage: string = "User Name is required";

  ispasswordValid: boolean = true;
  passwordValidationMessage: string = "Password is required";

  isconfirmpasswordValid: boolean = true;
  confirmpasswordValidationMessage: string = "Confirm Password is required";

  isemailAddressValid: boolean = true;
  emailAddressIdValidationMessage: string = "Email Address is required";
  isemailAddressPatternValid: boolean = true;
  emailAddressPatternValidationMessage: string = "Email Address is not valid";

}
